// =====================================================
// Golf Vinoř — Course Data (Prague City Golf)
// 18-hole links course, Par 72
// Designer: Jonathan Gaunt
// =====================================================

import { Course, CourseHole } from './types';

export const VINOR_HOLES: CourseHole[] = [
  // Front Nine (OUT) — Par 36
  { number: 1,  par: 4, si: 5 },
  { number: 2,  par: 4, si: 3 },
  { number: 3,  par: 5, si: 9 },
  { number: 4,  par: 4, si: 17 },
  { number: 5,  par: 4, si: 13 },
  { number: 6,  par: 3, si: 7 },
  { number: 7,  par: 5, si: 1 },
  { number: 8,  par: 3, si: 15 },
  { number: 9,  par: 4, si: 11 },
  // Back Nine (IN) — Par 36
  { number: 10, par: 4, si: 8 },
  { number: 11, par: 4, si: 18 },
  { number: 12, par: 4, si: 2 },
  { number: 13, par: 4, si: 14 },
  { number: 14, par: 5, si: 12 },
  { number: 15, par: 3, si: 4 },
  { number: 16, par: 4, si: 16 },
  { number: 17, par: 3, si: 10 },
  { number: 18, par: 5, si: 6 },
];

export const VINOR_COURSE: Course = {
  name: 'Golf Vinoř (Prague City Golf)',
  holes: VINOR_HOLES,
  totalPar: VINOR_HOLES.reduce((sum, h) => sum + h.par, 0), // 72
};

/** Get par for a specific hole number */
export function getHolePar(holeNumber: number): number {
  const hole = VINOR_HOLES.find(h => h.number === holeNumber);
  return hole?.par ?? 4;
}

/** Get front nine par total */
export function getFrontNinePar(): number {
  return VINOR_HOLES.filter(h => h.number <= 9).reduce((sum, h) => sum + h.par, 0);
}

/** Get back nine par total */
export function getBackNinePar(): number {
  return VINOR_HOLES.filter(h => h.number > 9).reduce((sum, h) => sum + h.par, 0);
}
